export default __webpack_public_path__ + "static/media/img-3.173a4ec6.jpg";